module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrlogin"
  }, [_c('div', {
    staticClass: "qrcode"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flash),
      expression: "flash"
    }],
    staticClass: "flash",
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Click to update QR code")]), _vm._v(" "), _c('Qrcode', {
    attrs: {
      "size": _vm.size,
      "cls": "code",
      "value": _vm.qrcode
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("Scan QR Code to login Vanish")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('div', {
    staticClass: "change"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_password@2x.png"),
      "alt": ""
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b208eea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Qrcode.vue
// module id = 740
// module chunks = 1